const DISHES_GROUPED_BY = {
  NONE: 'NONE',
  MEAL_TYPE: 'MEAL_TYPE',
  CATEGORY: 'CATEGORY',
} as const;

export type DishesGroupedBy =
  (typeof DISHES_GROUPED_BY)[keyof typeof DISHES_GROUPED_BY];

export const DISH_GROUP_FILTER_PARAM: { [key in DishesGroupedBy]: string } = {
  [DISHES_GROUPED_BY.NONE]: '',
  [DISHES_GROUPED_BY.MEAL_TYPE]: 'dish.sizes.mealType.id',
  [DISHES_GROUPED_BY.CATEGORY]: 'dish_categories_id',
};

export default DISHES_GROUPED_BY;
